import { Link } from "react-router-dom";
import { toast } from "sonner";
import { cn } from "@/lib/utils";
import type { NavChild } from "@/config/navigation";

interface SidebarChildItemProps {
  item: NavChild;
  isActive: boolean;
}

export function SidebarChildItem({ item, isActive }: SidebarChildItemProps) {
  const Icon = item.icon;

  const handleClick = (e: React.MouseEvent) => {
    if (item.notImplemented) {
      e.preventDefault();
      toast.info("Feature not available yet", {
        description: "This feature is coming soon!",
      });
    }
  };

  return (
    <Link
      to={item.href}
      onClick={handleClick}
      className={cn(
        "flex items-center gap-2 p-2 ml-6 rounded-md transition-all duration-200",
        "text-[hsl(var(--sidebar-text-muted))] hover:text-[hsl(var(--sidebar-text))]",
        "hover:bg-[hsl(var(--sidebar-accent-tint))]",
        isActive && [
          "text-[hsl(var(--sidebar-text))]",
          "bg-[hsl(var(--sidebar-accent-tint))]",
          "border-l-2 border-[hsl(var(--sidebar-accent))]",
        ],
        item.notImplemented && "opacity-60"
      )}
    >
      <Icon className="h-4 w-4 flex-shrink-0" />
      <span className="text-sm">{item.label}</span>
      {item.notImplemented && (
        <span className="text-xs bg-[hsl(var(--sidebar-border))] px-1.5 py-0.5 rounded text-[hsl(var(--sidebar-text-muted))]">
          Soon
        </span>
      )}
    </Link>
  );
}
